export default function ($siteNavigation, sections, totalSections) {

  if ($siteNavigation && $siteNavigation.length == 0) {
    return;
  }

  const siteNavigationHeight = $siteNavigation.offset().top + $siteNavigation.outerHeight(true);

  let cur = sections.map(function () {
    let sectionTop = $(this).offset().top;
    if (siteNavigationHeight > sectionTop)
      return this;
  });

  cur = cur[cur.length - 1];


  if (cur) {

    let sidenavClass = $(cur).attr('data-sidenav');

    if (!$('.js-side-navigation').hasClass(sidenavClass)) {
      $('.js-side-navigation').removeClass('nav-color');
      $('.js-side-navigation').removeClass('nav-wh');
      $('.js-side-navigation').removeClass('nav-none');
      $('.js-side-navigation').addClass(sidenavClass);
    }

    if ($(cur).hasAttr('data-section')) {
      let sectionNum = $(cur).attr('data-section');
      $(`.js-side-navigation ul li`).removeClass('active');
      $(`.js-side-navigation ul li:nth-child(${sectionNum})`).addClass('active');
      if (totalSections == sectionNum) {
        $('.js-side-navigation .below-text').addClass('inverse-arrow');
      } else {
        $('.js-side-navigation .below-text').removeClass('inverse-arrow');
      }
    }

    if ($(cur).hasAttr('data-title')) {
      let title = $(cur).attr('data-title');
      let section = $(cur).attr('data-section');
      let html = "";
      if (title && title.length > 0) {
        html = `
        <p class="font-medium">
          ${section}

          <span class="font-regular">/</span>

          ${totalSections}
          <span class="font-bold secondary-color bottom-space">${title}</span>
        </p>`;
      }

      if ($('.js-side-navigation .js-section-vertial-nav-text').html() != html) {
        $('.js-side-navigation .js-section-vertial-nav-text').html(html);
      }

    } else {
      $('.js-side-navigation .js-section-vertial-nav-text').html("<p></p>");
    }
  }

}
